<template>
    <div class="sub-visual overflow-hidden">
        <v-container>
            <template v-if="this.$slots['titleContents']">
                <slot name="titleContents" />
            </template>
            <h2 v-else class="font-size-30 font-size-md-60 font-size-lg-72 overflow-hidden">
                <span data-aos="fade" data-aos-duration="700">{{ title }}</span>
            </h2>
        </v-container>
        <div v-if="src" data-aos="fade" data-aos-duration="1500" class="sub-visual__img" :style="'background-image:url(' + src + ');'"></div>
    </div>
</template>

<script>
export default {
    props: {
        title: { type: String, default: "" },
        src: { type: String, default: "" },
    },
    components: {},
    data: () => {
        return {};
    },
    created() {},
    mounted() {
        this.init();
    },
    methods: {
        init: function() {
        },
    },
};
</script>

<style lang="scss" scoped>
.sub-visual {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    height: 200px;
    color: #fff;
    padding-top: var(--header-body);
    background-color: #000;
    >.container{
        position: relative;
        z-index: 2;
    }
    &__img {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
        width: 100%;
        height: 100%;
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
    }
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
    .sub-visual {
        height: 300px;
    }
}
@media (min-width: 1024px) {
    .sub-visual {
        height: 420px;
    }
}
@media (min-width: 1200px) {
}
</style>
